import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_fryzjer-artysta/artifacts/1zs7ekyu_logo.png";

const links = [
  { to: "/o-mnie", label: "O Mnie" },
  { to: "/uslugi", label: "Usługi" },
  { to: "/galeria", label: "Galeria" },
  { to: "/szkolenia", label: "Szkolenia" },
  { to: "/kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => { setOpen(false); }, [loc]);

  return (
    <header data-testid="navbar" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "bg-black/60 backdrop-blur-2xl border-b border-white/5" : "bg-transparent"}`}>
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3 group">
          <img src={LOGO} alt="Fryzjer Artysta" className="h-10 w-10 object-contain" />
          <div>
            <div className="font-anton text-xl text-white leading-none tracking-wide">FRYZJER</div>
            <div className="font-anton text-[10px] tracking-[0.4em] leading-none" style={{ color: "#A855F7" }}>ARTYSTA</div>
          </div>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-3 lg:gap-7">
          {links.map(l => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.to.replace("/","")}`}
              className={`text-xs lg:text-sm uppercase tracking-[0.1em] lg:tracking-[0.15em] transition-colors duration-200 whitespace-nowrap ${loc.pathname === l.to ? "text-white" : "text-white/50 hover:text-white"}`}>
              {l.label}
            </Link>
          ))}
          <Link to="/rezerwacja" data-testid="nav-rezerwacja-btn"
            className="btn-primary text-xs whitespace-nowrap" style={{ padding: "10px 16px" }}>
            Rezerwacja
          </Link>
        </nav>

        {/* Mobile toggle */}
        <button data-testid="navbar-menu-toggle" className="md:hidden text-white p-2" onClick={() => setOpen(!open)}>
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-black/95 backdrop-blur-2xl border-t border-white/5 px-6 py-8 flex flex-col gap-5 w-full overflow-hidden">
          {links.map(l => (
            <Link key={l.to} to={l.to} data-testid={`nav-mobile-${l.to.replace("/","")}`}
              className="text-white/70 text-base uppercase tracking-widest hover:text-white transition-colors">
              {l.label}
            </Link>
          ))}
          <Link to="/rezerwacja" data-testid="nav-mobile-rezerwacja"
            className="btn-primary text-sm text-center justify-center mt-2 w-full block">
            Zarezerwuj Wizytę
          </Link>
        </div>
      )}
    </header>
  );
}
